import React, { useState, useEffect} from 'react';
import { FiEdit2 } from "react-icons/fi";
import { FiTrash2 } from "react-icons/fi";
import { FiCheck } from "react-icons/fi";
import { FiX } from "react-icons/fi";

const TodoList = () => {
  const [todos, setTodos] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [editingIndex, setEditingIndex] = useState(-1);
  const [editedValue, setEditedValue] = useState('');


    // Load todos from localStorage || sessionStorage when the component mounts
    useEffect(() => {
      const storedTodos = JSON.parse(localStorage.getItem('todos'));
      if (storedTodos) {
        setTodos(storedTodos);
      }
    }, []);
  
    // Save todos to local storage whenever todos change
    useEffect(() => {
      localStorage.setItem('todos', JSON.stringify(todos));
    }, [todos]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const addTodo = () => {
    if (inputValue.trim() !== '') {
      setTodos([...todos, inputValue]);
      setInputValue('');
    }
  };

  const deleteTodo = (index) => {
    const updatedTodos = todos.filter((_, i) => i !== index);
    setTodos(updatedTodos);
  };

  const startEditing = (index, value) => {
    setEditingIndex(index);
    setEditedValue(value);
  };

  const cancelEditing = () => {
    setEditingIndex(-1);
    setEditedValue('');
  };

  const saveEditedTodo = (index) => {
    const updatedTodos = [...todos];
    updatedTodos[index] = editedValue;
    setTodos(updatedTodos);
    setEditingIndex(-1);
    setEditedValue('');
  };

  return (
    <div>
        <h2>CURD</h2>
      <input
        className='todoInput'
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder="Try adding some items"
      />
      <button className='project-btn' onClick={addTodo}>Add</button>
      <ul className='to-do-items'>
        <li className="pt-2 pb-2">Hey 👋, hope you are doing well 😇</li>
        {todos.map((todo, index) => (
          <li key={index} className="pb-2">
            {editingIndex === index ? (
              <>
                <input
                    className='todoInput'
                  type="text"
                  value={editedValue}
                  onChange={(e) => setEditedValue(e.target.value)}
                />
                <FiCheck className='to-do-items-edit' onClick={() => saveEditedTodo(index)}/>
                <FiX className='to-do-items-delete' onClick={cancelEditing}/>
              </>
            ) : (
              <>
                <span>{todo}</span>
                <FiEdit2 className='to-do-items-edit' onClick={() => startEditing(index, todo)}/>
                <FiTrash2 className='to-do-items-delete' onClick={() => deleteTodo(index)}/>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TodoList;
